import { useBemCN } from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { Layout } from "@gik/ui-legacy/gik/Layout/Layout";
import type React from "react";
import type { LandingPageHero } from "../types/LandingPageHero";

export interface ILandingPageHeroCardProps {
	hero: LandingPageHero;
}

/**
 * https://www.figma.com/design/FT2ninjhNiQOXfnOTaZfqy/%F0%9F%91%A8%F0%9F%8F%BC%E2%80%8D%F0%9F%8E%A4-Jade's-workspace-of-asset-creation?node-id=4696-8681&m=dev
 */
function LandingPageHeroCardComp({
	hero: { icon, animation, title, content },
	children,
}: React.PropsWithChildren<ILandingPageHeroCardProps>) {
	const bem = useBemCN("hero-card");

	return (
		<Layout {...bem()} direction={"column md:row"} gap={16}>
			<Layout
				element={"main"}
				direction={"column"}
				align={"start md:center"}
				perpendicular={"stretch md:start"}
				flex={"0 0 40%"}
				gap={4}
			>
				<h1 {...bem("heading", null, headingClassNames)}>{title}</h1>
				<p {...bem("content", null, contentClassNames)}>{content}</p>
				{children}
			</Layout>
		</Layout>
	);
}

export const LandingPageHeroCard = withComponentErrorBoundary(
	LandingPageHeroCardComp,
);

const headingClassNames = [
	"tw-font-heading",
	"tw-m-0",
	"tw-text-4xl",
	"tw-font-semibold",
	"tw-text-center",
	"md:tw-font-bold",
	"md:tw-text-6xl",
	"md:tw-text-left",
];
const contentClassNames = [
	"tw-font-body",
	"tw-text-base",
	"tw-font-normal",
	"tw-leading-5",
	"tw-text-center",
	"tw-m-0",
	"tw-mb-64",
	"md:tw-mb-0",
	"md:tw-text-xl",
	"md:tw-text-left",
];
